import { useEffect, useMemo } from 'react'

import { stepperValues } from '@itau-loans-www/constants'
import { useProposal } from '@itau-loans-www/hooks'
import ProposalTemplate from '@itau-loans-www/templates/layouts/Proposal'
import { useLocation } from '@reach/router'

const ProposalLayout = ({ children, hideStepper }) => {
  const { setIsLoading } = useProposal()
  const location = useLocation()
  const currentPage = useMemo(
    () => location.pathname.split('/proposta/')[1] ?? 'dados-pessoais',
    [location.pathname]
  )

  const stepValues = stepperValues[currentPage] || {
    title: '',
    stepNumber: 0
  }

  useEffect(() => {
    setIsLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  return (
    <ProposalTemplate
      maxSteps={5}
      currentPage={currentPage}
      stepTitle={stepValues.title}
      hideStepper={hideStepper}
      stepIndex={stepValues.stepNumberFGTS}
    >
      {children}
    </ProposalTemplate>
  )
}

export default ProposalLayout
